import {
  hasProofBody,
  panelRunFromSnapshot,
  type ProofRunSnapshot,
} from "./proofRun";

const PROOF_REPORT_ARTIFACT_PREFIX = "proof-report:";

export function proofReportArtifactId(childSessionId: string): string {
  return `${PROOF_REPORT_ARTIFACT_PREFIX}${childSessionId}`;
}

export function proofRoundArtifactId(
  childSessionId: string,
  runId: string,
): string {
  return `${proofReportArtifactId(childSessionId)}:${runId}`;
}

/** Where a settled report lives once a newer run replaces it; null when it has no round key. */
export function earlierRoundArtifactId(artifact: {
  childSessionId: string;
  roundId?: string;
  run: { run_id?: string };
}): string | null {
  const round = artifact.roundId ?? artifact.run.run_id;
  return round === undefined
    ? null
    : proofRoundArtifactId(artifact.childSessionId, round);
}

/** Stays the same when a shown report's live id is pinned to its round id, so the pane keeps its reading state. A run with no body or no run_id keys by its child, so gaining either, or a pin to a run-id-less round, does not remount it. */
export function artifactMountKey(
  artifact:
    | {
        kind: "proof_report";
        id: string;
        childSessionId: string;
        run: ProofRunSnapshot;
      }
    | { kind: string; id: string },
): string {
  if (artifact.kind !== "proof_report" || !("childSessionId" in artifact)) {
    return artifact.id;
  }
  const runId = artifact.run.run_id;
  return runId !== undefined && hasProofBody(panelRunFromSnapshot(artifact.run))
    ? proofRoundArtifactId(artifact.childSessionId, runId)
    : proofReportArtifactId(artifact.childSessionId);
}

/** `"proof-report:ses_1"` → `"ses_1"`; null for any other artifact id. */
export function proofReportChildId(artifactId: string | null): string | null {
  if (!artifactId?.startsWith(PROOF_REPORT_ARTIFACT_PREFIX)) return null;
  return (
    artifactId.slice(PROOF_REPORT_ARTIFACT_PREFIX.length).split(":")[0] || null
  );
}
